import React from 'react'
import { Box, Divider } from "@mui/material"

import { AppRetailerBlock } from "@components"


export default function siteColumn() {

	return [{
		name: 'site',
		label: 'Site',
		options: {
			display: 'excluded',
			customBodyRowRender: ({ main, competitor }) => `${main.name} vs ${competitor || "any"}`,
		}
	}, {
		name: 'site',
		label: 'Site',
		options: {
			filter: false,
			customBodyRowRenderLite: ({ main, competitor }) => <Box sx={{
				display: "flex",
				justifyContent: "center",
				alignItems: "center",
				flexDirection: "column"
			}}>
				<AppRetailerBlock
					country={main.market}
					retailer={main.name}
					icon={main.ico}
				/>
				{!!competitor && <>
					<Divider sx={{ my: 1, width: "80%", borderBottom: "2px solid" }}/>
					<AppRetailerBlock
						country={competitor.market}
						retailer={competitor.name}
						icon={competitor.ico}
					/>
				</>}
			</Box>
		}
	}]
}